// extracted by mini-css-extract-plugin
export default {"email-content":"EmailLink_email-content__OxLMu","email":"EmailLink_email__S+V3U","content-container-right":"EmailLink_content-container-right__DGULC"};